<template>
  <div id="app">
    <div class="conter">
      <router-view></router-view>
    </div>
    
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return {
      token:'',
      list:[],
      // index:0
    }
  },
  computed: {
    index() {
      return this.$store.state.index;
    }
  },
  created(){
    let token = localStorage.getItem('token')
    this.token = token
    
  },
  methods:{
    changeIndex(index) {
      this.$store.dispatch('updateIndex', index); // 提交变更
    },
    logout(){
      this.$confirm('溫馨提示', '退出登錄？', {
            confirmButtonText: '確定',
            showCancelButton: true,
            cancelButtonText: '取消',
            type: 'warning',
            callback: (res) => {
              if (res === 'confirm') {
                localStorage.setItem('token','')
                this.$router.push('/');
                location.reload()
              }
            }
          })
    },
    toProduct(type){
      console.log(type)
      localStorage.setItem('type',type)
      this.$router.push('/product');
    },
    toPage(path){
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss">
html,body{
  height: 100% !important;
  width: 100%;
  font-size: 16px;
  line-height: 1.4;
  font-weight: lighter;
}
/* 隐藏滚动条，但仍可滚动 */
.hide_s::-webkit-scrollbar,body::-webkit-scrollbar {
    display: none; /* 适用于 WebKit 浏览器（如 Chrome、Safari） */
}

.hide_s,html,body{
    -ms-overflow-style: none;  /* 适用于 IE 和 Edge */
    scrollbar-width: none;  /* 适用于 Firefox */
    margin: 0;
    padding: 0;
}
* {
  margin: 0;
  padding: 0;
}
/* 基础样式：清除所有a标签默认样式 */
a {
  /* 清除下划线 */
  text-decoration: none;
  /* 清除默认文字颜色（继承父元素颜色） */
  color: inherit;
  /* 清除点击后的外边框（部分浏览器默认有） */
  outline: none;
  /* 清除点击时的高亮效果（移动端） */
  -webkit-tap-highlight-color: transparent;
  /* 清除默认的鼠标样式（可选，根据需求调整） */
  cursor: pointer;
  /* 清除可能的内边距/外边距 */
  padding: 0;
  margin: 0;
  /* 清除默认的块/行内特性（可选，按需设置） */
  display: inline-block; /* 若需要块级特性可改为 block */
  /* 清除文字装饰的继承（如父元素有下划线时） */
  text-decoration-skip-ink: none;
}
ul,ol,li {
  list-style: none;
}
article, aside, details, figcaption, figure, footer, header, hgroup, main, nav, section, summary {
  display: block;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  font-size: 10px;
}

</style>
    